import SignIn from '@/app/modules/auth/components/sign-in/sign-in.vue';
import Register from '@/app/modules/auth/components/register/register.vue';
import ForgotPassword from '@/app/modules/auth/components/forgot-password/forgot-password.vue';
import NewPassword from '@/app/modules/auth/components/new-password/new-password.vue';
import ConfirmEmail from '@/app/modules/auth/components/confirm-email/confirm-email.vue';

export default {
  name: 'auth-container',
  components: {
    SignIn,
    Register,
    ForgotPassword,
    NewPassword,
    ConfirmEmail,
  },
};
